import { render, staticRenderFns } from "./createRessource.vue?vue&type=template&id=64fd813c&scoped=true&"
import script from "./createRessource.vue?vue&type=script&lang=js&"
export * from "./createRessource.vue?vue&type=script&lang=js&"
import style0 from "./createRessource.vue?vue&type=style&index=0&id=64fd813c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fd813c",
  null
  
)

export default component.exports